import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';

import config from '../config';

const meta = {
  title: 'Aftercare | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Aftercare | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

const AfterCareProvider = ({ region, providers }) => {
  return (
    <div className="card my-3" key={region}>
      <div className="card-header">
        <h4 className="fs-6 fw-normal">{region}</h4>
      </div>
      <div className="card-body">
        <ul className="list-group list-group-flush">
          {providers.map(({ area, caption, url }, idx) => (
            <li className="list-group-item" key={idx}>
              {area} &nbsp; - &nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="stretched-link text-decoration-none"
                href={url}
              >
                {caption}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default function Aftercare() {
  const [cmsData, setCmsData] = useState(undefined);
  const [search, setSearch] = useState([]);
  const [careProviders, setCareProviders] = useState([]);
  const [afterCareProviders, setAfterCareProviders] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/aftercare`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    const fetchCareCenters = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/items/atc?sort={"state":1,"city":1,"name":1}&fields={"state":1,"city":1,"name":1,"url":1}`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result.length) {
          const transformedResult = result.reduce((acc, item) => {
            let regionEntry = acc.find((r) => r.region === item.state);

            if (!regionEntry) {
              regionEntry = {
                region: item.state,
                providers: [],
              };
              acc.push(regionEntry);
            }

            regionEntry.providers.push({
              area: item.city,
              caption: item.name,
              url: item.url,
            });

            return acc;
          }, []);

          setCareProviders(transformedResult);
          setAfterCareProviders(transformedResult);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    fetchData();
    fetchCareCenters();
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      const searchTerm = search.toLowerCase();
      setAfterCareProviders(
        careProviders.filter((item) => {
          return item.region.toLowerCase().includes(searchTerm);
        }),
      );
    } else {
      setAfterCareProviders(careProviders);
    }
  }, [search]);

  return (
    <DocumentMeta {...meta}>
      <div className="aftercare-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            {cmsData && <h1>{cmsData.title || ''}</h1>}
          </div>
        </div>

        <section className="about section light-background py-4">
          <div className="container section-title pb-0">
            {cmsData && (
              <div
                className="col-lg-12 content section-title pb-3 cms-content"
                dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
              ></div>
            )}
          </div>
        </section>
        <section className="section">
          <Container>
            <div className="row">
              <div className="col-lg-8 col-md-8 col-12">&nbsp;</div>
              <div className="col-lg-4 col-md-4 col-12">
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search by state..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value.trim());
                  }}
                />
              </div>
            </div>
            {afterCareProviders.length > 0 &&
              afterCareProviders.map(({ region, providers }, idx) => (
                <AfterCareProvider
                  key={`${region}-${idx}`}
                  region={region}
                  providers={providers}
                />
              ))}
            {afterCareProviders.length == 0 && <div>No result found.</div>}
          </Container>
        </section>
      </div>
    </DocumentMeta>
  );
}
